/** Snapchat uses one scope for all Marketing API read and write access. */
export const SNAPCHAT_MARKETING_SCOPE = "snapchat-marketing-api";

export const SNAPCHAT_SCOPES = [SNAPCHAT_MARKETING_SCOPE];

export function snapchatGrants(
  held: ReadonlyArray<string>,
  required: string,
): boolean {
  return held.includes(required);
}
